<div class="modal-content" piqetAngularDraggable>
  <ng-container *ngrxLet="customFacade.conversionProcessList$ as conversionProcessList">
    <ng-container *ngrxLet="customFacade.GetCustomConversionProcessError$ as error">
      <div class="modal-header">
        <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">
          {{ modalLabel }}
        </div>

        <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
          <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
        </button>
      </div>
      <div class="body-modal" [ngClass]="{ 'disabled-popup': !checkEntireAccess }">
        <form id="frmProjectCreate" [formGroup]="customConversionForm">
          <div id="ProjectCreateValidationSummary" class="field-validation-error"></div>
          <div class="portlet light mainTitle">
            <div class="portlet-title">
              <div class="caption">
                <span class="font-sharp">Add process required to convert 1 kg of material </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group required">
                <piqet-angular-common-input
                  formControlName="conversionName"
                  [control]="customConversionForm.get('conversionName')"
                  label="Conversion process name"
                  placeholder="Conversion process name"
                  [maxLength]="50"
                  [submitted]="submitted"
                  [errorMessages]="{
                    required: 'Conversion process name is required',
                    whitespace: 'Conversion process name is required'
                  }"
                >
                </piqet-angular-common-input>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="form-group">
                <div class="services-form">
                  <textarea
                    formControlName="comment"
                    cols="20"
                    id="Comment"
                    name="Comment"
                    rows="2"
                    placeholder="comment"
                  ></textarea>
                  <label>Comment</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12" *ngIf="isHideDropDown">
              <div class="form-group required">
                <label
                  *ngIf="customConversionForm.get('organizationName')?.value"
                  class="sub-header-drpdown pb-2"
                  >Organization</label
                >
                <ng-select
                  [clearable]="true"
                  [clearOnBackspace]="false"
                  #material
                  [items]="organizationlist"
                  [searchable]="false"
                  bindLabel="name"
                  formControlName="organizationName"
                  [searchFn]="commonInputSearchForOrganization"
                  [readonly]="isDisabledDropDown"
                  placeholder="Organization"
                  [(ngModel)]="setOrganizationValue"
                  (change)="selectValue($event)"
                >
                  <ng-template ng-header-tmp>
                    <div class="has-feedback">
                      <input
                        type="text"
                        (input)="material.filter($any($event.target).value)"
                        class="accordion-search form-control search-input"
                        id="inputValidation"
                        placeholder="Search..."
                      />
                      <span class="form-control-feedback">
                        <i class="fa fa-search icon"></i>
                      </span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                    <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                  </ng-template>
                </ng-select>
                <div
                  *ngIf="
                    (customConversionForm.controls['organizationName']?.touched &&
                      customConversionForm.controls['organizationName']?.invalid) ||
                    customConversionForm.controls['organizationName'].value?.name ===
                      '-- Select Organization -- ' ||
                    (submitted && !customConversionForm.controls['organizationName'].value?.name)
                  "
                  class="input-error"
                >
                  Organization is required.
                </div>
              </div>
            </div>
          </div>
          <div formGroupName="conversionProcessForm">
            <div class="panel-body">
              <div class="portlet light mainTitle">
                <div class="portlet-title">
                  <div class="caption">
                    <span class="font-sharp"
                      >Conversion process manufacture of custom material</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div id="divmanufactureofmaterialList" class="grid-div cutomBtn-margin">
          <!-- <div class="input-error">
            <span>{{ error}}</span>
          </div> -->
          <input
            data-val="true"
            data-val-number="The field CustomMaterialId must be a number."
            data-val-required="The CustomMaterialId field is required."
            type="hidden"
            value="0"
          />
          <piqet-angular-portlet
            [columnDefs]="processColumnDef"
            [inlineEdit]="true"
            [isCheckOrgaizationReport]="true"
            [frameworkComponents]="frameworkComponents"
            [gridData]="conversionProcessList"
            [headerBtn]="headerBtn"
            [headerBtnName]="headerBtnName"
            [hidePagination]="true"
            [hideSearch]="true"
            [showErrorInAccordian]="true"
            [disableButton]="disableSubmit || isRowEditable"
            (editDataEvent)="checkValidation(conversionProcessList)"
            [error]="error || errorNotification"
            [isInlineGrid]="true"
            [class]="'overflowCheck'"
            [createAccess]="checkEntireAccess"
          >
          </piqet-angular-portlet>
        </div>
      </div>
      <div class="modal-footer box-footer">
        <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
        <button
          type="button"
          class="modelBtn purpleBtnHoverEffect"
          (click)="onSave(conversionProcessList)"
          [disabled]="disableSubmit || isRowEditable"
          *ngIf="checkEntireAccess"
        >
          Save
        </button>
      </div>
    </ng-container>
  </ng-container>
</div>
